import { fetchPath } from '.'

export const recordUsageData = (contactIri, action, data) => (
  fetchPath.run({
    path: '/yoda/api/usage-data',
    method: 'post',
    data: {
      contact: contactIri,
      action,
      data,
    },
  })
)
